import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(39, 60, 73, 0.8);
  z-index: 10000;

  @media ${sizes.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledPopup = styled.div`
  position: relative;
  margin: 20px auto;
  padding: 1em;
  border-radius: 10px;
  background-color: ${th('colors.turquoise')};
  ${({ small }) => small && `width: 500px; max-width: 100%;`};

  > h2 {
    color: ${th('colors.white')};
  }
`;

const sharedCloseIconLineStyle = css`
  content: ' ';
  position: absolute;
  top: 5px;
  left: 11px;
  width: 2px;
  height: 15px;
  background-color: ${th('colors.white')};
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 0.6em;
  right: 0.6em;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  background-color: ${th('colors.red')};
  cursor: pointer;

  ::before {
    ${sharedCloseIconLineStyle};
    transform: rotate(-45deg);
  }

  ::after {
    ${sharedCloseIconLineStyle};
    transform: rotate(45deg);
  }
`;
